import { Injectable } from '@angular/core';
import { ModalService } from 'ngx-lib';
import { lastValueFrom } from 'rxjs';
import { ForgotPasswordDto, LoginClient, LoginDto, TokenResultDto } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class LoginService {
    constructor(
        private readonly client: LoginClient,
        private readonly modalService: ModalService
    ) {}

    async authenticate(body: LoginDto | undefined): Promise<TokenResultDto> {
        return await lastValueFrom(this.client.loginAuthenticate(body));
    }

    async sendForgotPasswordRequest(body: ForgotPasswordDto): Promise<void> {
        await lastValueFrom(this.client.loginSendForgotPasswordRequest(body));
    }

    async logout(): Promise<void> {
        this.modalService.dismissAll();
        return await lastValueFrom(this.client.loginLogOut());
    }
}
